<script lang="ts">
  import { api } from '../../lib/api';

  let { reload }: { reload: () => void } = $props();
  let msg = $state<string | null>(null);
  let error = $state<string | null>(null);

  async function importFile(e: Event) {
    const file = (e.currentTarget as HTMLInputElement).files?.[0];
    if (!file) return;
    if (!confirm(`Replace the current sources, positions, tally and audio configuration with "${file.name}"?`)) return;
    error = msg = null;
    try {
      const text = await file.text();
      let body: unknown;
      try {
        body = JSON.parse(text);
      } catch {
        body = text; // YAML: parsed server-side
      }
      const res = await fetch('/api/admin/import', {
        method: 'POST',
        headers: { 'Content-Type': typeof body === 'string' ? 'text/plain' : 'application/json' },
        body: typeof body === 'string' ? body : JSON.stringify(body),
      });
      if (!res.ok) throw new Error((await res.json()).error ?? res.statusText);
      msg = 'Imported and applied.';
      reload();
    } catch (err) {
      error = (err as Error).message;
    }
  }
</script>

<div class="admin-grid">
  <section class="panel">
    <h3>Export</h3>
    <p class="muted">Save this show's configuration to reuse it on the next job.</p>
    <div class="row">
      <a href="/api/admin/export" download><button>Export show (JSON)</button></a>
      <a href="/api/admin/export?secrets=1" download><button>Export incl. users &amp; links</button></a>
    </div>
    <p class="muted small">The second file contains password hashes and link keys: store it like a password.</p>
  </section>
  <section class="panel">
    <h3>Import</h3>
    <p class="muted">Replaces sources, positions, tally providers and audio I/O; applies immediately. Users and links are only changed if the file contains them.</p>
    <input type="file" accept=".json,.yaml,.yml,application/json" onchange={importFile} />
    {#if msg}<p>{msg}</p>{/if}
    {#if error}<p class="error">{error}</p>{/if}
  </section>
</div>

<style>
  .small { font-size: 0.8rem; }
</style>
